/*
 * plannedVisitsTableController
 * */

class PlannedVisitsTableController {
	constructor($log, visitOverviewWidgetService) {
		'ngInject';
		this.$log = $log;
		this.openVisitDetails = visitOverviewWidgetService.openVisitDetails;
		this.openSubjectCalendar = visitOverviewWidgetService.openSubjectCalendar;
	}

	$onInit() {
		this.$log = this.$log.getInstance('PlannedVisitsTableController');
		this.$log.debug('loaded');
	}
}

export default PlannedVisitsTableController;
